module.exports = __webpack_public_path__ + "static/img/citrus.e631454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/citrus.png
// module id = UbWs
// module chunks = 0